export default __webpack_public_path__ + "static/Site_Banner_Insights_Carousel-e2301bc9d294932269daab20611aef2b.png";